export const FORMATIONS = {
  '4-4-2': {
    label: '4-4-2',
    slots: [{
      group: 'mv',
      x: 50,
      y: 8,
      label: 'MV'
    }, {
      group: 'fb',
      x: 12,
      y: 28,
      label: 'VB'
    }, {
      group: 'fb',
      x: 37,
      y: 25,
      label: 'MIB'
    }, {
      group: 'fb',
      x: 63,
      y: 25,
      label: 'MIB'
    }, {
      group: 'fb',
      x: 88,
      y: 28,
      label: 'HB'
    }, {
      group: 'mf',
      x: 12,
      y: 52,
      label: 'VY'
    }, {
      group: 'mf',
      x: 37,
      y: 50,
      label: 'CM'
    }, {
      group: 'mf',
      x: 63,
      y: 50,
      label: 'CM'
    }, {
      group: 'mf',
      x: 88,
      y: 52,
      label: 'HY'
    }, {
      group: 'af',
      x: 35,
      y: 78,
      label: 'AF'
    }, {
      group: 'af',
      x: 65,
      y: 78,
      label: 'AF'
    }]
  },
  '4-3-3': {
    label: '4-3-3',
    slots: [{
      group: 'mv',
      x: 50,
      y: 8,
      label: 'MV'
    }, {
      group: 'fb',
      x: 12,
      y: 28,
      label: 'VB'
    }, {
      group: 'fb',
      x: 37,
      y: 25,
      label: 'MIB'
    }, {
      group: 'fb',
      x: 63,
      y: 25,
      label: 'MIB'
    }, {
      group: 'fb',
      x: 88,
      y: 28,
      label: 'HB'
    }, {
      group: 'mf',
      x: 25,
      y: 50,
      label: 'VM'
    }, {
      group: 'mf',
      x: 50,
      y: 48,
      label: 'CM'
    }, {
      group: 'mf',
      x: 75,
      y: 50,
      label: 'HM'
    }, {
      group: 'af',
      x: 18,
      y: 78,
      label: 'VW'
    }, {
      group: 'af',
      x: 50,
      y: 80,
      label: 'CF'
    }, {
      group: 'af',
      x: 82,
      y: 78,
      label: 'HW'
    }]
  },
  '3-5-2': {
    label: '3-5-2',
    slots: [{
      group: 'mv',
      x: 50,
      y: 8,
      label: 'MV'
    }, {
      group: 'fb',
      x: 25,
      y: 26,
      label: 'VIB'
    }, {
      group: 'fb',
      x: 50,
      y: 24,
      label: 'MIB'
    }, {
      group: 'fb',
      x: 75,
      y: 26,
      label: 'HIB'
    }, {
      group: 'mf',
      x: 10,
      y: 50,
      label: 'VWB'
    }, {
      group: 'mf',
      x: 30,
      y: 48,
      label: 'CM'
    }, {
      group: 'mf',
      x: 50,
      y: 46,
      label: 'CM'
    }, {
      group: 'mf',
      x: 70,
      y: 48,
      label: 'CM'
    }, {
      group: 'mf',
      x: 90,
      y: 50,
      label: 'HWB'
    }, {
      group: 'af',
      x: 35,
      y: 78,
      label: 'AF'
    }, {
      group: 'af',
      x: 65,
      y: 78,
      label: 'AF'
    }]
  },
  '3-4-3': {
    label: '3-4-3',
    slots: [{
      group: 'mv',
      x: 50,
      y: 8,
      label: 'MV'
    }, {
      group: 'fb',
      x: 25,
      y: 26,
      label: 'VIB'
    }, {
      group: 'fb',
      x: 50,
      y: 24,
      label: 'MIB'
    }, {
      group: 'fb',
      x: 75,
      y: 26,
      label: 'HIB'
    }, {
      group: 'mf',
      x: 15,
      y: 50,
      label: 'VM'
    }, {
      group: 'mf',
      x: 40,
      y: 48,
      label: 'CM'
    }, {
      group: 'mf',
      x: 60,
      y: 48,
      label: 'CM'
    }, {
      group: 'mf',
      x: 85,
      y: 50,
      label: 'HM'
    }, {
      group: 'af',
      x: 18,
      y: 78,
      label: 'VW'
    }, {
      group: 'af',
      x: 50,
      y: 80,
      label: 'CF'
    }, {
      group: 'af',
      x: 82,
      y: 78,
      label: 'HW'
    }]
  },
  '4-2-3-1': {
    label: '4-2-3-1',
    slots: [{
      group: 'mv',
      x: 50,
      y: 8,
      label: 'MV'
    }, {
      group: 'fb',
      x: 12,
      y: 28,
      label: 'VB'
    }, {
      group: 'fb',
      x: 37,
      y: 25,
      label: 'MIB'
    }, {
      group: 'fb',
      x: 63,
      y: 25,
      label: 'MIB'
    }, {
      group: 'fb',
      x: 88,
      y: 28,
      label: 'HB'
    }, {
      group: 'mf',
      x: 35,
      y: 44,
      label: 'DM'
    }, {
      group: 'mf',
      x: 65,
      y: 44,
      label: 'DM'
    }, {
      group: 'mf',
      x: 18,
      y: 62,
      label: 'VY'
    }, {
      group: 'mf',
      x: 50,
      y: 60,
      label: 'AM'
    }, {
      group: 'mf',
      x: 82,
      y: 62,
      label: 'HY'
    }, {
      group: 'af',
      x: 50,
      y: 80,
      label: 'CF'
    }]
  },
  '5-3-2': {
    label: '5-3-2',
    slots: [{
      group: 'mv',
      x: 50,
      y: 8,
      label: 'MV'
    }, {
      group: 'fb',
      x: 10,
      y: 30,
      label: 'VWB'
    }, {
      group: 'fb',
      x: 30,
      y: 26,
      label: 'VIB'
    }, {
      group: 'fb',
      x: 50,
      y: 24,
      label: 'MIB'
    }, {
      group: 'fb',
      x: 70,
      y: 26,
      label: 'HIB'
    }, {
      group: 'fb',
      x: 90,
      y: 30,
      label: 'HWB'
    }, {
      group: 'mf',
      x: 25,
      y: 50,
      label: 'VM'
    }, {
      group: 'mf',
      x: 50,
      y: 48,
      label: 'CM'
    }, {
      group: 'mf',
      x: 75,
      y: 50,
      label: 'HM'
    }, {
      group: 'af',
      x: 35,
      y: 78,
      label: 'AF'
    }, {
      group: 'af',
      x: 65,
      y: 78,
      label: 'AF'
    }]
  },
  '5-4-1': {
    label: '5-4-1',
    slots: [{
      group: 'mv',
      x: 50,
      y: 8,
      label: 'MV'
    }, {
      group: 'fb',
      x: 10,
      y: 30,
      label: 'VWB'
    }, {
      group: 'fb',
      x: 30,
      y: 26,
      label: 'VIB'
    }, {
      group: 'fb',
      x: 50,
      y: 24,
      label: 'MIB'
    }, {
      group: 'fb',
      x: 70,
      y: 26,
      label: 'HIB'
    }, {
      group: 'fb',
      x: 90,
      y: 30,
      label: 'HWB'
    }, {
      group: 'mf',
      x: 12,
      y: 52,
      label: 'VY'
    }, {
      group: 'mf',
      x: 37,
      y: 50,
      label: 'CM'
    }, {
      group: 'mf',
      x: 63,
      y: 50,
      label: 'CM'
    }, {
      group: 'mf',
      x: 88,
      y: 52,
      label: 'HY'
    }, {
      group: 'af',
      x: 50,
      y: 80,
      label: 'CF'
    }]
  }
};
export const FORMATION_KEYS = Object.keys(FORMATIONS);
export const GROUP_LABELS = {
  mv: 'MV',
  fb: 'FB',
  mf: 'MF',
  af: 'AF'
};
flarum.reg.add('ois-lineup', 'forum/utils/formations', { FORMATIONS: FORMATIONS,FORMATION_KEYS: FORMATION_KEYS,GROUP_LABELS: GROUP_LABELS, });